import axios from 'axios';

import { getDecodedStartappQuery, isDev } from '@/shared/helpers';
import { logErrorMini } from '@/shared/services/service-logger/lib/log-error-mini';

import { getBaseUrl } from '../helpers';

export const getTokenAuth = async (initData: string): Promise<string> => {
  const isTest = isDev('both');
  const decodedStartapp = getDecodedStartappQuery();

  let modifiedInitData = initData;

  if (decodedStartapp.src) {
    modifiedInitData = `${modifiedInitData}&src=${decodedStartapp.src}`;
  }

  if (decodedStartapp.ref) {
    modifiedInitData = `${modifiedInitData}&ref=${decodedStartapp.ref}`;
  }

  if (decodedStartapp.labels?.length) {
    modifiedInitData = `${modifiedInitData}&labels=${decodedStartapp.labels.toString()}`;
  }

  const encodedInitData = encodeURIComponent(modifiedInitData);
  const url = `${getBaseUrl()}/v1/oauth?isTest=${isTest}&initData=${encodedInitData}`;

  try {
    const res = await axios.post(url, {});
    return res.data?.token;
  } catch (error) {
    void logErrorMini(error as Error, 'getTokenAuth', {
      initData,
      modifiedInitData,
      encodedInitData,
      decodedStartapp,
    });
    throw error;
  }
};
